export default {
  title: 'Zespół',
  tooltip: 'Kliknij aby poznać nasz zespół',
  noResults: 'Brak wyników',
};
